var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import FileUpload from "~/components/common/file-upload.vue";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace("collection-execution");
var AddCaseTelRecord = /** @class */ (function (_super) {
    __extends(AddCaseTelRecord, _super);
    function AddCaseTelRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.rules = {
            custType: [{ required: true, message: '请输入催收对象' }],
            targetName: [{ required: true, message: '请输入姓名' }],
            followupBack: [{ required: true, message: '请选择行动代码' }],
            targetPhone: [{ required: true, message: '请输入联系电话' }],
        };
        _this.submitLoading = false;
        _this.applyModel = {
            remark: '',
            promiseAmt: '',
            targetPhone: '',
            targetName: '',
            custType: '',
            caseId: '',
            followupBack: '',
            checkTime: '',
            followContent: ''
        };
        return _this;
    }
    AddCaseTelRecord.prototype.phoneDataChange = function (value) {
        this.applyModel.targetPhone = value.phone;
        this.applyModel.targetName = value.contName;
        this.applyModel.custType = value.custType;
        this.applyModel.id = value.id;
    };
    AddCaseTelRecord.prototype.close = function () {
        var form = this.$refs["form"];
        form.resetFields();
        this.fileList = [];
    };
    AddCaseTelRecord.prototype.emitSuccess = function () { };
    AddCaseTelRecord.prototype.commit = function () {
        var _this = this;
        var fileLists = this.fileList.map(function (item) {
            return item.response;
        });
        var form = this.$refs["form"];
        form.validate(function (result) {
            if (!result)
                return;
            if (_this.menuChannel === MENU_CHANNEL.Assist_tel) {
                _this.applyModel.assistId = _this.otherData.assistId;
            }
            _this.applyModel.caseId = _this.caseId;
            var params = __assign(__assign({}, _this.applyModel), { files: JSON.stringify(fileLists) });
            _this.submitLoading = true;
            _this.caseOperatorPageService
                .addCaseTelRecord(params)
                .subscribe(function (data) {
                _this.submitLoading = false;
                _this.$message.success("添加成功");
                _this.fileList = [];
                _this.close();
                _this.emitSuccess();
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    AddCaseTelRecord.prototype.setCheckTime = function () {
        if (!this.applyModel.followupBack) {
            this.applyModel.checkTime = '';
        }
        if (this.applyModel.followupBack === 'PTP' ||
            this.applyModel.followupBack === 'CAPT') {
            var currentTime = new Date();
            this.applyModel.checkTime = this.$filter.dateTimeFormat(new Date((currentTime / 1000 + 86400 * 3) * 1000));
        }
        else {
            var currentTime = new Date();
            this.applyModel.checkTime = this.$filter.dateTimeFormat(new Date((currentTime / 1000 + 86400) * 1000));
        }
    };
    AddCaseTelRecord.prototype.onUploadRemove = function (file, fileList) {
        this.fileList = fileList;
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], AddCaseTelRecord.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Prop({ required: true })
    ], AddCaseTelRecord.prototype, "phoneData", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], AddCaseTelRecord.prototype, "showInput", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddCaseTelRecord.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddCaseTelRecord.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddCaseTelRecord.prototype, "otherData", void 0);
    __decorate([
        Watch("phoneData", { immediate: true })
    ], AddCaseTelRecord.prototype, "phoneDataChange", null);
    __decorate([
        Emit("close")
    ], AddCaseTelRecord.prototype, "close", null);
    __decorate([
        Emit('success')
    ], AddCaseTelRecord.prototype, "emitSuccess", null);
    AddCaseTelRecord = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
            },
        })
    ], AddCaseTelRecord);
    return AddCaseTelRecord;
}(Vue));
export default AddCaseTelRecord;
